import {DateTimeService,} from 'src/app/core/utils/datetime.service';
import {ComplementosModel} from './complementos.model';
import {DatosBasicos} from './datos-basicos.model';
import {DatosContacto} from './datos-contacto.model';
import {Direccion} from './direccion.model';
import {Identidad} from './identidad.model';
import {InformacionLaboral} from './info-laboral.model';
import {Parentesco} from './parentesco.model';
import {
  agregarDocumentoRNEC,
  agregarDocumentosNoExigibles,
  mapearASolicitudDocumentos,
} from './solicitud-documentos-mapper';
import {SolicitudTiposEnum} from './solicitud-tipos.enum';
import {Afiliado} from '../../afiliate/afilado';
import {ValidateData} from '../../../utils/validate-data';
import {InformationFormatting} from '../../../helpers/information-formatting/information-formatting';

export class Titular extends ComplementosModel {
  public motivo?: string;
  public identidad = Identidad.instance();
  public datosBasicos = DatosBasicos.instance();
  public fechaExpedicion: string;
  public nacionalidad: string;
  public infoLaboral = InformacionLaboral.instance();
  public datosContacto = DatosContacto.instance();
  public direccion = Direccion.instace();
  public estadoCivil: number;
  public grupoTitular: number;
  public parentesco = Parentesco.instance();

  static mapearDesdeFormularioAFT(obj: object): any {
    const titularDto = Titular.instance();
    const solicitudTipo = SolicitudTiposEnum.AFT;
    let horasDiarias = parseInt(`${obj["HorasLabDiaTrabajador"]}`);

    titularDto.identidad = {
      tipo: obj["TipoIdTrabajador"],
      numero: obj["NumIdTrabajador"]
    };

    titularDto.datosBasicos = {
      primerNombre: obj["Nombre1Trabajador"],
      segundoNombre: obj["Nombre2Trabajador"] || '',
      primerApellido: obj["Apellido1Trabajador"],
      segundoApellido: obj["Apellido2Trabajador"],
      fechaNacimiento: obj["FechaNaciTrabajador"],
      edad: DateTimeService.calcularEdad(obj["FechaNaciTrabajador"]),
      genero: obj["GeneroTrabajador"],
      corregidos: false
    };

    titularDto.fechaExpedicion = obj["FechaIngresoTrabajador"];
    titularDto.nacionalidad =
      obj["NacionalidadTrabajador"]["nationality_SAP"] || "";
    titularDto.infoLaboral = {
      tipoActividad: this.obtenerTipoActividadTrabajador(obj["TipoActTrabajador"]),
      ingresos: {
        salario: {
          tipo: obj["TipSalarioTrabajador"],
          basico: obj["SalarioTrabajador"],
        },
      },
      contrato: {
        tipo: obj["TipoContraTrabajador"],
        horasDiaria: horasDiarias.toString(),
        horasMes: obj["HorasLabMesTrabajador"],
        fechaIngreso: obj["FechaIngresoTrabajador"],
      },
    };

    titularDto.datosContacto = {
      correoElectronico: this.obtenerCorreo(obj['EmailTrabajador']),
      celular: obj["TelefonoCelTrabajador"],
      telefono: obj["TelefonoResTrabajador"],
    };

    titularDto.direccion = {
      departamento: {
        codigo: `${obj["DepartamentoResTrabajador"]["department_CODE"]}`,
        nombre: `${obj["DepartamentoResTrabajador"]["department_DESC"]}`,
      },
      ciudad: {
        codigo: `${obj["CiudadResTrabajador"]["municipality_CODE"]}`,
        nombre: `${obj["CiudadResTrabajador"]["municipality_DESC"]}`,
      },
      direccionPrincipal: `${obj["DireccionResTrabajador"]}`,
    };

    (titularDto.estadoCivil = +obj["EstadoCivilTrabajador"]["codigo"]),
      (titularDto.grupoTitular = 4),
      (titularDto.parentesco = {
        tipoParentesco: "TITULAR",
        codigoParentesco: "SUB-0001",
      });

    let complementos = [];
    if (obj["documents"]) {
      complementos = mapearASolicitudDocumentos(
        solicitudTipo,
        obj["documents"]
      );
    }

    if (obj["base64Valid"]) {
      agregarDocumentoRNEC(solicitudTipo, obj["base64Valid"], complementos, false, true);
    }

    if (obj["documentsNoExigibles"]) {
      agregarDocumentosNoExigibles(
        solicitudTipo,
        obj["documentsNoExigibles"],
        complementos
      );
    }

    titularDto.complementos = complementos;
    return titularDto;
  }

  static mapearDesdeFormularioNCM(obj: object): any {
    const titularDto = Titular.instance();
    const solicitudTipo = SolicitudTiposEnum.AFT;
    let horasDiarias = parseInt(`${obj["HorasLabDiaTrabajador"]}`);

    titularDto.identidad = {
      tipo: obj["TipoIdTrabajador"],
      numero: obj["NumIdTrabajador"]
    };

    titularDto.datosBasicos = {
      primerNombre: obj["Nombre1Trabajador"],
      segundoNombre: obj["Nombre2Trabajador"] || '',
      primerApellido: obj["Apellido1Trabajador"],
      segundoApellido: obj["Apellido2Trabajador"],
      fechaNacimiento: obj["FechaNaciTrabajador"],
      edad: DateTimeService.calcularEdad(obj["FechaNaciTrabajador"]),
      genero: obj["GeneroTrabajador"]
    };

    titularDto.fechaExpedicion = obj["FechaIngresoTrabajador"];
    titularDto.nacionalidad =
      obj["NacionalidadTrabajador"]["nationality_SAP"] || "";
    titularDto.infoLaboral = {
      tipoActividad: obj["TipoActTrabajador"],
      ingresos: {
        salario: {
          tipo: obj["TipSalarioTrabajador"],
          basico: obj["SalarioTrabajador"],
        },
      },
      contrato: {
        tipo: obj["TipoContraTrabajador"],
        horasDiaria: horasDiarias.toString(),
        horasMes: obj["HorasLabMesTrabajador"],
        fechaIngreso: obj["FechaIngresoTrabajador"],
      },
    };

    titularDto.datosContacto = {
      correoElectronico: this.obtenerCorreo(obj['EmailTrabajador']),
      celular: obj["TelefonoCelTrabajador"],
      telefono: obj["TelefonoResTrabajador"],
    };

    titularDto.direccion = {
      departamento: {
        codigo: `${obj["DepartamentoResTrabajador"]["department_CODE"]}`,
        nombre: `${obj["DepartamentoResTrabajador"]["department_DESC"]}`,
      },
      ciudad: {
        codigo: `${obj["CiudadResTrabajador"]["municipality_CODE"]}`,
        nombre: `${obj["CiudadResTrabajador"]["municipality_DESC"]}`,
      },
      direccionPrincipal: `${obj["DireccionResTrabajador"]}`,
    };

    (titularDto.estadoCivil = +obj["EstadoCivilTrabajador"]["codigo"]),
      (titularDto.grupoTitular = 4),
      (titularDto.parentesco = {
        tipoParentesco: "TITULAR",
        codigoParentesco: "SUB-0001",
      });

    let complementos = [];
    if (obj["documents"]) {
      complementos = mapearASolicitudDocumentos(
        solicitudTipo,
        obj["documents"]
      );
    }

    if (obj["base64Valid"]) {
      agregarDocumentoRNEC(solicitudTipo, obj["base64Valid"], complementos, false, true);
    }

    if (obj["documentsNoExigibles"]) {
      agregarDocumentosNoExigibles(
        solicitudTipo,
        obj["documentsNoExigibles"],
        complementos
      );
    }

    titularDto.complementos = complementos;
    return titularDto;
  }

  static mapearDesdeFormularioRIT(obj: object, motivo: any): any {
    const titularDto = Titular.instance();
    const solicitudTipo = SolicitudTiposEnum.RIT;
    let horasDiarias = parseInt(`${obj["afiliacion"]["horasLaboradas"]}`);
    titularDto.motivo = motivo?.toString() || "";
    titularDto.identidad = {
      tipo: obj["tipoDocumento"],
      numero: obj["numeroDocumento"],
    };
    titularDto.datosBasicos = {
      primerNombre: obj["primerNombre"],
      segundoNombre: obj["segundoNombre"] || '',
      primerApellido: obj["primerApellido"],
      segundoApellido: obj["segundoApellido"] || '',
      fechaNacimiento: DateTimeService.quitarHora(obj["fechaNacimiento"]),
      edad: DateTimeService.calcularEdad(obj["fechaNacimiento"]),
      genero: obj["genero"],
    };

    titularDto.fechaExpedicion = obj["fechaIngresoTrabajador"] || "";
    titularDto.nacionalidad = obj["nacionalidadTrabajador"] || "CO";

    const diasDelMes = 30;
    const horasMensuales = horasDiarias * diasDelMes;

    titularDto.infoLaboral = {
      tipoActividad: obj["afiliacion"]['tipoCargo'],
      ingresos: {
        salario: {
          tipo: obj["afiliacion"]['tipoSalario'],
          basico: obj["afiliacion"]['salario']
        }
      },
      contrato: {
        tipo: obj["afiliacion"]['tipoCargo'],
        horasDiaria: horasDiarias.toString(),
        horasMes: horasMensuales.toString(),
        fechaIngreso: obj["afiliacion"]['fechaAfiliacion'],
      }
    };

    titularDto.datosContacto = {
      correoElectronico: this.obtenerCorreo(obj['correoElectronico']),
      celular: obj["celular"] || "0",
      telefono: obj["telefono"] || ""
    };

    titularDto.direccion = {
      departamento: {
        codigo: obj["direccion"]["departamento"]["id"],
        nombre: obj["direccion"]["departamento"]["nombre"] || ""
      },
      ciudad: {
        codigo: obj["direccion"]["ciudad"]["id"] || '11',
        nombre: obj["direccion"]["ciudad"]["nombre"] || ""
      },
      direccionPrincipal: obj["direccion"]["direccionPrincipal"]
    };

    titularDto.estadoCivil = +obj["estadoCivil"];
    titularDto.grupoTitular = 4
    titularDto.parentesco = {
      tipoParentesco: "TITULAR",
      codigoParentesco: "SUB-0001",
    };

    let complementos = [];
    if (obj["documents"]) {
      const crearComplementoVacio = !obj["documents"];
      complementos = mapearASolicitudDocumentos(
        solicitudTipo,
        obj["documents"],
        crearComplementoVacio
      );
    }

    if (complementos.length === 0) {
      complementos.push({[solicitudTipo]: []});
    }
    titularDto.complementos = complementos;
    return titularDto;
  }

  static mapearDesdeFormularioRIB(obj: object): any {
    const titularDto = Titular.instance();
    const horasWork = `${obj["afiliacion"]["horasLaboradas"]}`
    let horasDiarias = parseInt(horasWork);

    titularDto.identidad = {
      tipo: obj["tipoDocumento"],
      numero: obj["numeroDocumento"],
    };
    titularDto.datosBasicos = {
      primerNombre: obj["primerNombre"] || "",
      segundoNombre: obj["segundoNombre"] || "",
      primerApellido: obj["primerApellido"] || "",
      segundoApellido: obj["segundoApellido"] || "",
      fechaNacimiento: DateTimeService.quitarHora(obj["fechaNacimiento"]),
      edad: DateTimeService.calcularEdad(obj["fechaNacimiento"]),
      genero: obj["genero"],
    };

    titularDto.fechaExpedicion = obj["fechaIngresoTrabajador"] || "";
    titularDto.nacionalidad = obj["nacionalidadTrabajador"] || "CO";

    titularDto.infoLaboral = {
      tipoActividad: obj["afiliacion"]['tipoCargo'] || "",
      ingresos: {
        salario: {
          tipo: obj["afiliacion"]['tipoSalario'] || "",
          basico: obj["afiliacion"]['salario'] || ""
        }
      },
      contrato: {
        tipo: obj["afiliacion"]['tipoCargo'] || "",
        horasDiaria: horasDiarias.toString(),
        horasMes: obj["afiliacion"]['horasMes'] || "",
        fechaIngreso: obj["afiliacion"]['fechaAfiliacion'],
      }
    };

    titularDto.datosContacto = {
      correoElectronico: this.obtenerCorreo(obj["correoElectronico"]),
      celular: obj["celular"] || "0",
      telefono: obj["telefono"] || ""
    };

    titularDto.direccion = {
      departamento: {
        codigo: obj["direccion"]["departamento"]["id"],
        nombre: obj["direccion"]["departamento"]["nombre"] || ""
      },
      ciudad: {
        codigo: obj["direccion"]["ciudad"]["id"] || "",
        nombre: obj["direccion"]["ciudad"]["nombre"] || ""
      },
      direccionPrincipal: obj["direccion"]["direccionPrincipal"]
    };

    titularDto.estadoCivil = obj["estadoCivil"];
    titularDto.grupoTitular = 4
    titularDto.parentesco = {
      tipoParentesco: "TITULAR",
      codigoParentesco: "SUB-0001",
    };
    titularDto.complementos = [];
    return titularDto;
  }

  static mapearDesdeFormularioCEC(titular: Afiliado) {
    const titularDto = Titular.instance();
    const solicitudTipo = SolicitudTiposEnum.CEC;
    let horasDiarias = parseInt(`${titular["HorasLabDiaTrabajador"]}`);

    titularDto.identidad = {
      tipo: titular["TipoIdTrabajador"],
      numero: titular["NumIdTrabajador"]
    };

    titularDto.datosBasicos = {
      primerNombre: titular["Nombre1Trabajador"],
      segundoNombre: titular["Nombre2Trabajador"] || '',
      primerApellido: titular["Apellido1Trabajador"],
      segundoApellido: titular["Apellido2Trabajador"],
      fechaNacimiento: titular["FechaNaciTrabajador"],
      edad: DateTimeService.calcularEdad(titular["FechaNaciTrabajador"]),
      genero: titular["GeneroTrabajador"]
    };

    titularDto.fechaExpedicion = titular["FechaIngresoTrabajador"];
    titularDto.nacionalidad = titular["NacionalidadTrabajador"]["nationality_SAP"] || '';
    titularDto.infoLaboral = {
      tipoActividad: this.obtenerTipoActividadTrabajador(titular["TipoActTrabajador"]),
      ingresos: {
        salario: {
          tipo: titular["TipSalarioTrabajador"],
          basico: titular["SalarioTrabajador"]
        }
      },
      contrato: {
        tipo: InformationFormatting.returnNumberContractType(titular["TipoContraTrabajador"]),
        horasDiaria: horasDiarias.toString(),
        horasMes: titular["HorasLabMesTrabajador"],
        fechaIngreso: titular["FechaIngresoTrabajador"]
      }
    };

    titularDto.datosContacto = {
      correoElectronico: this.obtenerCorreo(titular["EmailTrabajador"]),
      celular: titular["TelefonoCelTrabajador"],
      telefono: titular["TelefonoResTrabajador"]
    };

    titularDto.direccion = {
      departamento: {
        codigo: `${titular["DepartamentoResTrabajador"]["department_CODE"]}`,
        nombre: `${titular["DepartamentoResTrabajador"]["department_DESC"]}`
      },
      ciudad: {
        codigo: `${titular["CiudadResTrabajador"]["municipality_CODE"]}`,
        nombre: `${titular["CiudadResTrabajador"]["municipality_DESC"]}`
      },
      direccionPrincipal: `${titular["DireccionResTrabajador"]}`
    };

    titularDto.estadoCivil = +titular["EstadoCivilTrabajador"]["codigo"],
      titularDto.grupoTitular = 4,
      titularDto.parentesco = {
        tipoParentesco: "TITULAR",
        codigoParentesco: "SUB-0001"
      }
    titularDto.complementos = [];
    return titularDto;
  }

  static instance() {
    return new this();
  }

  static obtenerCorreo(correo: string): string {
    return !ValidateData.emptyString(correo) ? correo : 'no@registra.com'
  }

  static obtenerTipoActividadTrabajador(TipoActTrabajador: string): string {
    return !ValidateData.emptyString(TipoActTrabajador) ? TipoActTrabajador : '01'
  }
}
